import styled from 'styled-components';
import { PropsWithChildren } from 'react';

type ArticleWrapperProps = PropsWithChildren & {
  margin?: string;
};

function ArticleWrapper({ margin, children }: ArticleWrapperProps) {
  return <StyledArticle $margin={margin}>{children}</StyledArticle>;
}

const StyledArticle = styled.div<{ $margin?: string }>`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  margin: ${({ $margin }) => $margin};
`;

export default ArticleWrapper;
